import { useEffect, useRef, useState } from "react";

interface UsePlaybackPositionRestoreProps {
  currentTime: number;
  key?: string;
  seek: (time: number) => void;
}

export const usePlaybackPositionRestore = ({
  currentTime,
  key,
  seek,
}: UsePlaybackPositionRestoreProps) => {
  const [customPlaybackRestoreTime, setCustomPlaybackRestoreTime] = useState<
    number | null
  >(null);
  const [savedPlaybackTime, setSavedPlaybackTime] = useState<number | null>(
    null,
  );
  const currentTimeRef = useRef(0);

  useEffect(() => {
    currentTimeRef.current = currentTime;
  }, [currentTime]);

  useEffect(() => {
    if (!key || currentTimeRef.current === 0 || customPlaybackRestoreTime)
      return;

    setSavedPlaybackTime(currentTimeRef.current);
  }, [key, customPlaybackRestoreTime]);

  const restorePlaybackPosition = () => {
    const restoredTime = customPlaybackRestoreTime || savedPlaybackTime;

    if (!restoredTime) return;

    currentTimeRef.current = restoredTime;

    setCustomPlaybackRestoreTime(null);
    setSavedPlaybackTime(null);
    seek(restoredTime);
  };

  return {
    setCustomPlaybackRestoreTime,
    restorePlaybackPosition,
  };
};
